import { useApi } from '@/composables/useApi'

const api = useApi()

// eslint-disable-next-line import/prefer-default-export
export function AnalyticService() {
  this.getDashBoardGrl = function (IdUser, TypeDate = '') {
    return new Promise((resolve, reject) => {
      try {
        const params = TypeDate !== null ? TypeDate : {}
        api.get(`/get/booster/getViewerDashBoard/${IdUser}`, {
          params,
        })
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
  this.getByIdVsl = function (vslId, type_date = '') {
    return new Promise((resolve, reject) => {
      try {
        const params = type_date !== null ? type_date : {}
        api.get(`/get/booster/analytic/vslsData/${vslId}`, {
          params,
        })
          .then(res => {
            resolve(res.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }
  this.getByIdVslObjts = function (vslId, type_date = '') {
    return new Promise((resolve, reject) => {
      try {
        const params = type_date !== null ? type_date : {}
        api.get(`/get/booster/analytic/vslsDataOBJ/${vslId}`, {
          params,
        })
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
  this.getDashBoardTempoTodo = function (IdUser) {
    return new Promise((resolve, reject) => {
      try {
        api.get(`/get/booster/getDashBoardTempoTodo/${IdUser}`)
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
  this.getDashBoardTempoTodoVsl_Id = function (vsl_id) {
    return new Promise((resolve, reject) => {
      try {
        api.get(`/get/booster/getDashBoardTempoTodoVsl_Id/${vsl_id}`)
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}
